package com.nonopn.skywatcher.common.app.pages.map.model.weather

import eu.codlab.weather.common.models.WeatherConditionMap

class WeatherCoded(val weatherCoded: String) {
    val coverage: Coverage?
    val intensity: Intensity
    val weather: WeatherConditionMap?

    init {
        val split = weatherCoded.split(":")
        coverage = split.getOrNull(0)?.let { code -> Coverage.entries.find { it.code == code } }
        intensity = split.getOrNull(1)?.let { code -> Intensity.entries.find { it.code == code } }
            ?: Intensity.Moderate

        weather = when (split.getOrNull(2)) {
            "A" -> WeatherConditionMap.Thunderstorm // Hail - TOOD ?
            "BD" -> WeatherConditionMap.DustSandWhirls
            "BN" -> WeatherConditionMap.Sand
            "BR" -> WeatherConditionMap.Mist
            "BS" -> WeatherConditionMap.SnowShower
            "BY" -> WeatherConditionMap.RainShower
            "F" -> WeatherConditionMap.Fog
            "FC" -> WeatherConditionMap.CloudsOvercast // Funnel CLoud
            "FR" -> WeatherConditionMap.SnowLight // Frost
            "H" -> WeatherConditionMap.Haze
            "IC" -> WeatherConditionMap.SnowLight // Ice Crystal
            "IF" -> WeatherConditionMap.Fog // Ice Fog
            "IP" -> WeatherConditionMap.SnowSleet // Ice pellets / Sleet
            "K" -> WeatherConditionMap.Smoke
            "L" -> WeatherConditionMap.Drizzle
            "R" -> WeatherConditionMap.RainModerate
            "RW" -> WeatherConditionMap.RainShower
            "RS" -> WeatherConditionMap.SnowAndRain
            "SI" -> WeatherConditionMap.SnowSleet
            "WM" -> WeatherConditionMap.SnowShowerSleet
            "S" -> WeatherConditionMap.Snow
            "SW" -> WeatherConditionMap.SnowShower
            "T" -> WeatherConditionMap.Thunderstorm
            "TO" -> WeatherConditionMap.Tornado
            "UP" -> WeatherConditionMap.RainModerate
            "VA" -> WeatherConditionMap.Ash
            "WP" -> WeatherConditionMap.RainLight
            "ZF" -> WeatherConditionMap.Fog
            "ZL" -> WeatherConditionMap.Drizzle // Freezing
            "ZR" -> WeatherConditionMap.DrizzleRain
            "ZY" -> WeatherConditionMap.RainFreezing
            "CL" -> WeatherConditionMap.Clear
            "FW" -> WeatherConditionMap.CloudsFew
            "SC" -> WeatherConditionMap.CloudsScattered
            "BK" -> WeatherConditionMap.CloudsBroken
            "OV" -> WeatherConditionMap.CloudsOvercast
            else -> null
        }

    }
}

enum class Coverage(val code: String) {
    AreasOf("AR"),
    Brief("BR"),
    ChanceOf("C"),
    Definite("D"),
    Frequent("FQ"),
    Intermittent("IN"),
    Isolated("IS"),
    Likely("L"),
    Numerous("NM"),
    Occasional("O"),
    Patchy("PA"),
    PeriodsOf("PD"),
    SlightChance("S"),
    Scattered("SC"),
    Nearby("VC"),
    WideSpread("WD")
}

enum class Intensity(val code: String) {
    VeryLight("VL"),
    Light("L"),
    Heavy("H"),
    VeryHeavy("VH"),
    Moderate("")
}
